<template>
  <div class="container">
    <div style="padding: 20px 30px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <h2>会议室管理</h2>
        <a-space>
          <a-input-search
            placeholder="搜索会议室名称"
            v-model="searchName"
            style="width: 200px"
            @pressEnter="handleSearch"
          />
          <a-select v-model="searchStatus" placeholder="状态" style="width: 120px">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">停用</a-select-option>
          </a-select>
          <a-button type="primary" @click="handleSearch">
            搜索
          </a-button>
          <a-button @click="resetSearch">
            重置
          </a-button>
          <a-button type="primary" @click="handleAdd">
            + 新增会议室
          </a-button>
        </a-space>
      </div>

      <a-table
        :columns="columns"
        :data-source="roomList"
        row-key="id"
        :loading="loading"
        style="width: 100%"
      >
        <template slot="imageUrl" slot-scope="text">
          <a-avatar :src="text ? `/api/meeting/getImage?path=${text}` : ''" size="40" shape="square" v-if="text" />
          <a-avatar size="40" shape="square" v-else>无</a-avatar>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-tag :color="(record && record.status == 1) ? 'green' : 'red'">
            {{ (record && record.status == 1) ? '启用' : '停用' }}
          </a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button size="small" @click="handleEdit(record)">
            编辑
          </a-button>
          <a-button size="small" @click="handleDelete(record)">
            删除
          </a-button>
        </template>
      </a-table>
    </div>
    
    <!-- 新增/编辑对话框 -->
    <a-modal
      v-model="modalVisible"
      :title="modalTitle"
      @ok="handleOk"
      @cancel="handleCancel"
      width="800px"
      :footer="null"
    >
      <div style="position: relative;">
        <div style="position: absolute; top: 0; right: 0;">
          <a-button @click="handleCancel" style="margin-right: 8px;">返回</a-button>
        </div>
        
        <a-form :form="form" layout="vertical">
          <h3 style="font-size: 16px; font-weight: 500; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 1px solid #e8e8e8;">基本信息</h3>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 24px;">
            <a-form-item label="会议室名称" :required="true">
              <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入会议室名称' }] }]" placeholder="请输入会议室名称" />
            </a-form-item>
            <a-form-item label="位置" :required="true">
              <a-input v-decorator="['location', { rules: [{ required: true, message: '请输入位置' }] }]" placeholder="请输入会议室位置，如：行政楼3层" />
            </a-form-item>
            <a-form-item label="容量" :required="true">
              <a-input-number v-decorator="['capacity', { rules: [{ required: true, message: '请输入容量' }] }]" :min="1" placeholder="请输入会议室容量（人数）" style="width: 100%" />
            </a-form-item>
            <a-form-item label="最少参会人数" :required="true">
              <a-input-number v-decorator="['minAttendees', { rules: [{ required: true, message: '请输入最少参会人数' }] }]" :min="0" placeholder="请输入最少参会人数" style="width: 100%" />
            </a-form-item>
            <a-form-item label="管理部门" :required="true">
              <a-select v-decorator="['manageDeptId', { rules: [{ required: true, message: '请选择管理部门' }] }]" style="width: 100%">
                <a-select-option v-for="dept in deptList" :key="dept.id" :value="dept.id">{{ dept.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="状态" :required="true">
              <a-radio-group v-decorator="['status', { rules: [{ required: true, message: '请选择状态' }] }]">
                <a-radio value="1">启用</a-radio>
                <a-radio value="0">停用</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          
          <h3 style="font-size: 16px; font-weight: 500; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 1px solid #e8e8e8;">会议室图片</h3>
          <a-form-item>
            <a-upload
              list-type="picture-card"
              :file-list="fileList"
              :before-upload="beforeUpload"
              @change="handleChange"
              :custom-request="customUpload"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" style="font-size: 28px; color: #999;" />
                <p style="margin-top: 8px; color: #999; font-size: 14px;">上传图片</p>
              </div>
            </a-upload>
          </a-form-item>
          
          <h3 style="font-size: 16px; font-weight: 500; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 1px solid #e8e8e8;">设备清单</h3>
          <a-form-item>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
              <span style="font-size: 14px;">设备列表</span>
              <a-button type="link" @click="addEquipment" style="font-size: 14px;">+ 添加设备</a-button>
            </div>
            <div v-if="equipmentList.length === 0" style="text-align: center; padding: 40px 0; color: #999; font-size: 14px;">
              暂无设备，请点击添加设备
            </div>
            <div v-else style="border: 1px solid #e8e8e8; border-radius: 4px; overflow: hidden;">
              <div v-for="(equipment, index) in equipmentList" :key="index" style="display: flex; align-items: center; padding: 16px; border-bottom: 1px solid #e8e8e8;">
                <a-input v-model="equipment.name" style="flex: 1;" placeholder="设备名称" />
                <div style="margin-left: 16px;">
                  <a-button type="link" @click="editEquipment(index)" style="margin-right: 16px; color: #1890ff;">
                    <a-icon type="edit" />
                  </a-button>
                  <a-button type="link" @click="deleteEquipment(index)" style="color: #ff4d4f;">
                    <a-icon type="delete" />
                  </a-button>
                </div>
              </div>
            </div>
          </a-form-item>
          
          <h3 style="font-size: 16px; font-weight: 500; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 1px solid #e8e8e8;">描述</h3>
          <a-form-item>
            <a-textarea v-decorator="['description']" placeholder="请输入会议室的补充说明信息，如使用注意事项、特殊设备操作说明等" rows="4" style="width: 100%;" />
          </a-form-item>
          
          <div style="display: flex; justify-content: flex-end; margin-top: 32px; padding-top: 20px; border-top: 1px solid #e8e8e8;">
            <a-button @click="handleCancel" style="margin-right: 16px;">取消</a-button>
            <a-button type="primary" @click="handleOk">保存</a-button>
          </div>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>
import meetingApi from '@/services/meeting'
import { queryOrganList } from '@/services/organMgr'

export default {
  name: 'MeetingRoomList',
  data() {
    return {
      loading: false,
      roomList: [],
      modalVisible: false,
      modalTitle: '',
      form: this.$form.createForm(this),
      searchName: '',
      searchStatus: '',
      fileList: [],
      equipmentList: [],
      currentRecord: null,
      deptList: [], // 部门列表
      columns: [
        {
          title: '会议室名称',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '图片',
          dataIndex: 'imageUrl',
          key: 'imageUrl',
          scopedSlots: { customRender: 'imageUrl' }
        },
        {
          title: '位置',
          dataIndex: 'location',
          key: 'location'
        },
        {
          title: '容量',
          dataIndex: 'capacity',
          key: 'capacity',
          customRender: (text) => text + '人'
        },
        {
          title: '最少参会人数',
          dataIndex: 'minAttendees',
          key: 'minAttendees',
          customRender: (text) => text + '人'
        },
        {
          title: '管理部门',
          dataIndex: 'manageDeptId',
          key: 'manageDeptId',
          customRender: (text) => {
            const dept = this.deptList.find(item => item.id === text)
            return dept ? dept.name : text
          }
        },
        {
          title: '设备配置',
          dataIndex: 'equipmentList',
          key: 'equipmentList',
          customRender: (text) => {
            if (typeof text === 'string') {
              return text.split(',').join('、')
            }
            return text
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData()
    this.loadDeptList()
  },
  methods: {
    loadData(params) {
      this.loading = true
      meetingApi.manageRoomList(params).then(res => {
        if (res.data && res.data.code === 200) {
          this.roomList = res.data.data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    
    handleSearch() {
      const searchParams = {}
      if (this.searchName) {
        searchParams.name = this.searchName
      }
      if (this.searchStatus !== '') {
        searchParams.status = parseInt(this.searchStatus)
      }
      this.loadData(searchParams)
    },
    
    resetSearch() {
      this.searchName = ''
      this.searchStatus = ''
      this.loadData({})
    },
    
    loadDeptList() {
      // 加载处室组织架构（类型为3）
      queryOrganList({ inputType: 3 }).then(res => {
        if (res.data && res.data.code === 200) {
          const organData = res.data.data
          this.deptList = this.flattenOrganTree(organData)
        }
      })
    },
    
    // 扁平化组织树，获取所有部门
    flattenOrganTree(treeData) {
      const result = []
      
      function traverse(node) {
        if (node.key && node.title) {
          result.push({ id: node.key, name: node.title })
        }
        if (node.children && node.children.length > 0) {
          node.children.forEach(child => traverse(child))
        }
      }
      
      treeData.forEach(node => traverse(node))
      return result
    },
    handleAdd() {
      this.modalTitle = '新增会议室'
      this.currentRecord = null
      this.fileList = []
      this.equipmentList = []
      this.form.resetFields()
      this.form.setFieldsValue({ status: 1 })
      this.modalVisible = true
    },
    handleEdit(record) {
      this.modalTitle = '编辑会议室'
      this.currentRecord = record
      this.fileList = []
      this.equipmentList = []
      if (record.imageUrl) {
        // 构建完整的图片访问URL
        const imageUrl = `/api/meeting/getImage?path=${record.imageUrl}`
        this.fileList = [{
          uid: Date.now(),
          name: 'meeting-room.jpg',
          status: 'done',
          url: imageUrl
        }]
      }
      if (record.equipmentList) {
        if (typeof record.equipmentList === 'string') {
          this.equipmentList = record.equipmentList.split(',').map(item => ({ name: item.trim() }))
        } else if (Array.isArray(record.equipmentList)) {
          this.equipmentList = record.equipmentList.map(item => ({ name: item.name || item }))
        }
      }
      this.form.resetFields()
      this.modalVisible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: record.name,
          location: record.location,
          capacity: record.capacity,
          minAttendees: record.minAttendees,
          manageDeptId: record.manageDeptId,
          status: String(record.status),
          description: record.description
        })
      })
    },
    addEquipment() {
      this.equipmentList.push({ name: '' })
    },
    editEquipment(index) {
      // 编辑设备，这里可以打开一个编辑对话框，或者直接在当前位置编辑
    },
    deleteEquipment(index) {
      this.equipmentList.splice(index, 1)
    },
    handleDelete(record) {
      this.$confirm(`确定要删除会议室「${record.name}」吗？`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        meetingApi.deleteRoom({ id: record.id }).then(res => {
          if (res.data && res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(res.data ? res.data.message : '删除失败')
          }
        })
      })
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 过滤空设备名称
          const validEquipments = this.equipmentList.filter(item => item.name && item.name.trim())
          const equipmentListStr = validEquipments.map(item => item.name.trim()).join(',')
          
          // 提取图片相对路径，数据库只保存相对路径
          let imageUrl = ''
          if (this.fileList.length > 0) {
            const url = this.fileList[0].url
            if (url.includes('?path=')) {
              // 从完整URL中提取相对路径
              imageUrl = url.split('?path=')[1]
            } else {
              // 直接使用url（可能是旧数据）
              imageUrl = url
            }
          }
          
          // 获取选中的部门名称
          const selectedDeptId = values.manageDeptId
          const selectedDept = this.deptList.find(dept => dept.id === selectedDeptId)
          
          const data = {
            ...values,
            imageUrl: imageUrl,
            equipmentList: equipmentListStr,
            manageDeptName: selectedDept ? selectedDept.name : ''
          }
          if (this.currentRecord) {
            data.id = this.currentRecord.id
          }
          meetingApi.saveRoom(data).then(res => {
            if (res.data && res.data.code === 200) {
              this.$message.success('保存成功')
              this.modalVisible = false
              this.loadData()
            } else {
              this.$message.error(res.data ? res.data.message : '保存失败')
            }
          })
        }
      })
    },
    handleCancel() {
      this.modalVisible = false
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传 JPG/PNG 图片！')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！')
        return false
      }
      return true // 返回true，允许默认上传
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'error') {
        this.$message.error('图片上传失败')
        return
      }
      if (info.file.status === 'removed') {
        this.fileList = info.fileList
      }
    },
    customUpload(options) {
      
      const file = options.file
      // 自定义上传逻辑
      const formData = new FormData()
      formData.append('file', file)
      
      meetingApi.uploadImage(formData).then(res => {
        debugger
        if (res.data && res.data.code === 200) {
          // 上传成功，添加到文件列表
          this.fileList = [{
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: `/api/meeting/getImage?path=${res.data.filePath}`
          }]
          options.onSuccess()
        } else {
          this.$message.error(res.data ? res.data.message : '图片上传失败')
          options.onError()
        }
      }).catch(err => {
        this.$message.error('图片上传失败！')
        options.onError()
      })
    }
  }
}
</script>

<style scoped>
.container {
  background: #fff;
  min-height: 750px;
}
</style>
